<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Info - Document</h1>
        <button type="button" class="ps-2 action-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <br />
    <mat-divider></mat-divider>
    <br />
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Categorie</strong></h4>
        <p class="col-md-6">
            {{ group.category_name ? group.category_name : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Dată creat</strong></h4>
        <p class="col-md-6">
            {{ group.created_at ? (group.created_at | date: "dd.MM.yyyy" : "ro") : "n/a" }}
        </p>
    </div>
    <div *ngIf="group.updated_at > group.created_at" class="d-flex row">
        <h4 class="col-md-6"><strong>Ultima actualizare</strong></h4>
        <p class="col-md-6">
            {{ group.updated_at ? (group.updated_at | date: "dd.MM.yyyy" : "ro") : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Număr document</strong></h4>
        <p class="col-md-6">
            {{ group.document_nr ? group.document_nr : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Dată document</strong></h4>
        <p class="col-md-6">
            {{ group.document_date ? (group.document_date | date: "dd.MM.yyyy" : "ro") : "n/a" }}
        </p>
    </div>
    <div class="d-flex row">
        <h4 class="col-md-6"><strong>Observații</strong></h4>
        <p class="col-md-6">
            {{ group.observations ? group.observations : "n/a" }}
        </p>
    </div>
    <ng-container *ngIf="group.category_slug === 'dosar-medical'">
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Secțiune</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.medical_section ? getDocumentSectionsName(group.metadata.medical_section) : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tip condiție medicală</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.medical_condition_type ?
                getConditieMedicalaName(group.metadata.medical_condition_type) : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tip eveniment genealogic</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.genealogical_event_type ?
                getEvenimentGenealogic(group.metadata.genealogical_event_type) : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Medic</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.doctor_name ? group.metadata.doctor_name : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Clinică</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.clinic_name ? group.metadata.clinic_name : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Diagnostic</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.diagnosis ? group.metadata.diagnosis : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tratament</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.treatment ? group.metadata.treatment : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Data următorului control</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.date_next_checkup ? (group.metadata.date_next_checkup | date: "dd.MM.yyyy" : "ro") :
                "n/a" }}
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="group.category_slug === 'dosar-educational'">
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Instituție</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.institution_name ? group.metadata.institution_name : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Locație</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.location ? group.metadata.location : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tip Studii</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.degree_type ? group.metadata.degree_type : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Specializare</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.specialization ? group.metadata.specialization : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Status</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.edu_status ? getEduStatusName(group.metadata.edu_status) : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Dată începere</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.date_from ? (group.metadata.date_from | date: "dd.MM.yyyy" : "ro") : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Dată finalizare</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.date_to ? (group.metadata.date_to | date: "dd.MM.yyyy" : "ro") : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Are întreruperi în studii</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.has_breaks ? "Da" : "Nu" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Detalii întreruperi</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.break_details ? group.metadata.break_details : "n/a" }}
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="group.category_slug === 'dosar-juridic'">
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Instanță</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.court_name ? group.metadata.court_name : "n/a" }}
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="group.category_slug === 'dosar-psihologic'">
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Specialist</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.specialist_name ? group.metadata.specialist_name : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Tip evaluare</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.evaluation_type ? group.metadata.evaluation_type : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Diagnostic</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.diagnosis ? group.metadata.diagnosis : "n/a" }}
            </p>
        </div>
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Recomandări</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.recommendations ? group.metadata.recommendations : "n/a" }}
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="group.category_slug === 'dosar-familial'">
        <div class="d-flex row">
            <h4 class="col-md-6"><strong>Subtip Document</strong></h4>
            <p class="col-md-6">
                {{ group.metadata.document_subtype ? group.metadata.document_subtype : "n/a" }}
            </p>
        </div>
        <ng-container *ngIf="group.metadata.involved_persons && group.metadata.involved_persons.length > 0">
            <h4><strong>Persoane implicate</strong></h4>
            <div>
                <div *ngFor="let person of group.metadata.involved_persons; let i = index"
                    class="border rounded p-2 mb-2 d-flex justify-content-between align-items-center">
                    <div>
                        <strong>{{ person.full_name }}</strong>
                        <span *ngIf="person.cnp"> (CNP: {{ person.cnp }})</span>
                        <br>
                        <small>Relație: {{ person.relationship_type_name }}</small>
                        <span *ngIf="person.relationship_specific_name"> | Grad rudenie: {{
                            person.relationship_specific_name
                            }}</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <mat-divider></mat-divider>
    <br />
    <div class="section-label mb-1">Documente încărcate</div>
    <div class="doc-files-row">
        <button *ngFor="let file of group.files" type="button" class="doc-file-btn" (click)="downloadFile(file.id)">
            <i class="fa-solid fa-download"></i>
            {{ file.original_name }}
        </button>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>